import { render, staticRenderFns } from "./SupplyPalletNew.vue?vue&type=template&id=785d447a"
import script from "./SupplyPalletNew.vue?vue&type=script&lang=js"
export * from "./SupplyPalletNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports